<template>
<svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 1.04656L7.95344 0L4.5 3.45344L1.04656 0L0 1.04656L3.45344 4.5L0 7.95344L1.04656 9L4.5 5.54656L7.95344 9L9 7.95344L5.54656 4.5L9 1.04656Z" fill="#082964"/>
</svg>
</template>
